module.exports = require("next/head");